// extracted by mini-css-extract-plugin
export var Wrapper = "Wrapper-module--Wrapper--pD7tk";
export var Diptych = "Wrapper-module--Diptych--mU5NW";
export var Ingredient = "Wrapper-module--Ingredient--AHxTH";
export var Text = "Wrapper-module--Text--Q-zi0";
export var Bold = "Wrapper-module--Bold--Z0DzT";
export var Tasting = "Wrapper-module--Tasting--ttFlM";
export var Ingredients = "Wrapper-module--Ingredients--94VFt";
export var BaseIngredients = "Wrapper-module--BaseIngredients--qTzLO";
export var ShowIngredients = "Wrapper-module--ShowIngredients--0sdK2";
export var Hide = "Wrapper-module--Hide--7yf5O";
export var Show = "Wrapper-module--Show--Tm86P";
export var Highlights = "Wrapper-module--Highlights--Hnq9y";
export var Image = "Wrapper-module--Image--719Mv";